import React from 'react';
import { ComingSoon } from '../../components/ComingSoon';

const Checklist = () => {
  return (
    <ComingSoon heading="Check List">
      <div className="text-sm text-gray-500 font-medium mt-4">🚧 Coming Soon Feature</div>
    </ComingSoon>
  );
};

export default Checklist;